"use strict";

const EventTargetImpl = require("../events/EventTarget-impl").implementation;

class PerformanceImpl extends EventTargetImpl {
  constructor(args, privateData) {
    super(args, privateData);

    this._rawPerformance = privateData.rawPerformance;
  }

  now() {
    return this._rawPerformance.now();
  }

  get timeOrigin() {
    return this._rawPerformance.timeOrigin;
  }

  toJSON() {
    return this._rawPerformance.toJSON();
  }
}

exports.implementation = PerformanceImpl;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jsdom@13.2.0@jsdom/lib/jsdom/living/hr-time/Performance-impl.js
// module id = jx0q
// module chunks = 0